import React, { useState } from "react";

interface MenuItem {
	value: string;
	label: string;
}

interface DropdownProps {
	label: string;
	menuItems: MenuItem[];
	value: string;
	onChange: (value: string) => void;
}

const Dropdown: React.FC<DropdownProps> = ({
	label,
	menuItems,
	value,
	onChange,
}) => {
	const [isOpen, setIsOpen] = useState(false);

	const handleSelect = (selectedValue: string) => {
		onChange(selectedValue);
		setIsOpen(false);
	};

	return (
		<div className="relative w-full flex flex-col items-start justify-center py-2">
			<span className="block text-md font-Poppins font-semibold text-gray-700 mb-2 w-full text-left">
				{label}
			</span>

			<div className="relative w-full">
				{/* Dropdown Button */}
				<button
					type="button"
					onClick={() => setIsOpen(!isOpen)}
					className="w-full font-Poppins font-semibold bg-gray-100 border border-gray-300 shadow-sm px-4 py-2 text-left focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-700 flex justify-between items-center"
				>
					<span className="font-Poppins font-semibold text-md">
						{menuItems.find((item) => item.value === value)
							?.label || "Select an option"}
					</span>
					<svg
						className="w-5 h-5 text-gray-400"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="2"
							d="M19 9l-7 7-7-7"
						/>
					</svg>
				</button>

				{/* Dropdown Menu */}
				{isOpen && (
					<ul className="absolute z-10 w-full font-Poppins font-semibold text-left bg-white border border-gray-300 mt-1 shadow-lg max-h-60 overflow-auto">
						{menuItems.map((item) => (
							<li
								key={item.value}
								onClick={() => handleSelect(item.value)}
								className={`px-4 py-2 text-md text-gray-700 hover:bg-gray-100 cursor-pointer ${
									item.value === value ? "bg-blue-100" : ""
								}`}
							>
								{item.label}
							</li>
						))}
					</ul>
				)}
			</div>
		</div>
	);
};

export default Dropdown;
